import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  // 30-second timeout prevents requests from hanging indefinitely when the
  // backend is slow or unreachable, which would leave the UI in a permanent
  // loading state with no way to recover.
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("neivai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Registered by AuthProvider so a 401 (e.g. a salesperson session
// invalidated by a login elsewhere) clears in-memory auth state too, not
// just localStorage — otherwise the tab keeps rendering as if still logged
// in until a manual reload.
let onUnauthorized = () => {};
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn || (() => {});
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err.config?.url?.includes("/auth/me")) {
      const detail = err?.response?.data?.detail || "";
      localStorage.removeItem("neivai_token");
      localStorage.removeItem("neivai_user");
      onUnauthorized(detail);
    }
    return Promise.reject(err);
  }
);

export const resolveMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

// A plain `<a download href={resolveMediaUrl(url)}>` is silently ignored by
// the browser for cross-origin hrefs — which every rendered image is here
// (Cloudinary/Azure/a different dev port) — so clicking it just opens the
// image instead of saving it. Routing through this same-origin proxy, which
// sets Content-Disposition: attachment, forces the save dialog regardless of
// where the asset actually lives.
export const downloadAssetUrl = (url, filename = "neiv-render.jpg") => {
  if (!url) return "";
  return `${API_BASE}/uploads/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}`;
};
